export const getActions = (item, isAdmin, sectionId) => {
  const actions = {
        actions: [
            {
                label: 'Editar',
                icon: 'edit',
                action: 'edit',
            },
            {
                label: 'Cambiar fecha de proximo contacto',
                icon: 'date',
                action: 'changeNextContactDate',
            },
            {
                label: 'Añadir contacto',
                icon: 'add',
                action: 'addContact',
            },
            {
                label: 'Añadir observación',
                icon: 'comment',
                action: 'addObservation',
            },
        ],
        extra: [],
    };

    if (sectionId === 'no-llamar' && item.no_llamar) {
        actions.actions.push({
            label: 'Pasar a interesados',
            icon: 'check',
            action: 'moveToInterested',
        });
    }

    if (item.no_llamar && isAdmin) {
        actions.actions.push({
            label: 'Eliminar',
            icon: 'delete',
            action: 'delete',
        });
    }
    
    return actions;
};
